import React, { Component, createRef } from "react";
import ValidationText from "../../utils/validation/ValidationText.js";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import { CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import moment from "moment";
import ProductionServices from "../../services/axioServices/apiServices/ProductionServices.js";
import * as XLSX from "xlsx";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import { FinancealYearStartDateEndDate } from "../../utils/FinancialYearStartDateEndDate.js";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";
import { printFunction } from "../../components/print/printTemplate.js";

class ProductionBatchRegister extends Component {
  constructor(props) {
    super(props);
    this.printRef = createRef();
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.productionServices = new ProductionServices();
    this.SwalServices = new SwalServices();
    this.state = {
      companyName: '',
      productionRequisitionList: [],
      itemCategoryList: [],
      tableStatus: "",
      filterDetails: {
        startDate: "",
        endDate: "",
        sortBy: "Detail",
        itemCategory: "",
        itemId: "",
        productionStageId: [3, 4, 5],
      },
      totalCount: 0,
      noItemFound: "",
      categoryTotals: [],
      productDropdownList: [],
      typeList: [{ material: "Detail" }, { material: "Summary" }],
      validState: {
        isValid: true,
        error: {},
      },
      validationRules: {
        startDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "start date"
            ),
          },
        ],
        endDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "end date"
            ),
          },
        ],
      },
    };
  }

  componentDidMount() {
    let dates = FinancealYearStartDateEndDate()
    let filterDetails = this.state.filterDetails
    filterDetails.startDate = dates.startDate
    filterDetails.endDate = dates.endDate
    this.setState({ filterDetails: filterDetails })
    this.getAllItemCategory();
    const company = getAuthProps()
    this.setState({ companyName: company?.companyName })
  }

  getAllProductionBatchRegister = () => {
    this.setState({ tableStatus: "Loading..." }, () => {
      let isAllFieldsValidate = this.isAllFieldsValidate()
      if (isAllFieldsValidate) {
        let request = this.state.filterDetails;
        this.productionServices
          .getAllProductionBatchRegister(request)
          .then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
              if (response.responseData.length === 0) {
                this.setState({ tableStatus: "No Record Found" })
              } else {
                this.setState({ tableStatus: "" })
              }
              let res = response.responseData;
              const categoryTotals = this.state.itemCategoryList.map(category => {
                const totalBatchSize = res
                  .filter(record => record.productId.productCategory === category.categoryName)
                  .reduce((sum, record) => sum + record.batchSize, 0);
                return { category: category.categoryName, totalBatchSize };
              })
                .filter(item => item.totalBatchSize > 0);;

              let totalCount = res.length
              this.setState({ productionRequisitionList: res, totalCount: totalCount, categoryTotals: categoryTotals });
            } else {
              this.setState({ tableStatus: "" })
              this.SwalServices.Error(
                response.Message
              );
            }
          });
      }
    })
  };


  getAllItemCategory = () => {
    this.commonServices.getAllItemCategory().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.categoryName,
          value: item._id,
        }));
        this.setState(
          { itemCategoryList: dropdownItems }, () => {
            this.getAllProductDropdown();
          });
      } else {
        this.getAllProductDropdown();
        this.SwalServices.Error(response.Message);
      }
    });
  };
  getAllProductDropdown = () => {
    this.commonServices.getAllProductDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.productName,
          value: item._id,
        }));
        this.setState({ productDropdownList: dropdownItems });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  isAllFieldsValidate = () => {
    const newValidState = isValidForm(
      this.state.filterDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.filterDetails;
    details[name] = value;
    this.setState({ filterDetails: details });
  };

  handleDropdownChange = (e, name) => {
    const value = e.target.value;
    let details = this.state.filterDetails;
    details[name] = value;
    this.setState({ filterDetails: details }
    );
  };

  setFilterParameters = (selected, drpIdentity) => {
    let details = this.state.filterDetails;
    details[drpIdentity] = selected.value;
    details.productName = selected.label
    this.setState({ filterDetails: details });
  };

  render() {
    return (
      <div className="jobChargesReport-page">
        <div className="item-search !mb-2.5">
          <div className="item-grp flex gap-2.5 mb-3">
            <div className="search-grp w-[20%]">
              <label>Category</label>
              <MultiSelectDropdown
                drpIdentity="itemCategory"
                options={this.state.itemCategoryList}
                closeMenuOnSelect={true}
                hideSelectedOptions={true}
                onChange={(selected) =>
                  this.setFilterParameters(selected, "itemCategory")
                }
                allowSelectAll={false}
                value={this.state.itemCategoryList.filter(
                  (party) =>
                    party.value === this.state.filterDetails.itemCategory
                )}
              />
            </div>
            <div className="input-grp w-[35%]">
              <label>Product</label>
              <MultiSelectDropdown
                drpIdentity="itemId"
                options={this.state.productDropdownList}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={(selected) =>
                  this.setFilterParameters(selected, "itemId", "filterDetails")
                }
                allowSelectAll={false}
                value={this.state.productDropdownList.filter(
                  (party) => party.value === this.state.filterDetails.itemId
                )}
              />
            </div>
            <div className="input-grp w-[15%]">
              <label>Start Date</label>
              <input
                className={`inputFocus ${this.state.validState?.error?.startDate ? "errorInput" : ""}`}
                type="date"
                id="startDate"
                name="startDate"
                value={this.state.filterDetails.startDate}
                onChange={(event) => this.handleChange(event, "startDate")}
              />
              {/* <ValidationText error={this.state.validState.error.startDate} /> */}
            </div>
            <div className="input-grp w-[15%]">
              <label>End Date</label>
              <input
                className={`inputFocus ${this.state.validState?.error?.endDate ? "errorInput" : ""}`}
                type="date"
                id="endDate"
                name="endDate"
                value={this.state.filterDetails.endDate}
                onChange={(event) => this.handleChange(event, "endDate")}
              />
              {/* <ValidationText error={this.state.validState.error.endDate} /> */}
            </div>
            <div className="input-grp w-[15%]">
              <label>Sort By</label>
              <select
                value={this.state.filterDetails.sortBy}
                onChange={(e) => this.handleDropdownChange(e, "sortBy")}
              >
                {this.state.typeList.map((x, key) => (
                  <option key={key} value={x.material}>
                    {x.material}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="btn-grp">
            <button
              class="search-btn"
              onClick={() => this.getAllProductionBatchRegister()}

            >
              Search
            </button>
            {this.state.totalCount > 0 ? (
              <button
                class="print-btn"
                onClick={() => printFunction()}
              >
                Print
              </button>
            ) : null}
          </div>
        </div>
        <div className="total-count">
          <p className="mb-[3px] text-[15px] font-medium text-[#474747]">Total Count :- {this.state.totalCount}</p>
        </div>
        <div class="item-listing">
          <div className="hidden print-title">
            <h4>Production Register</h4>
            {this.state.filterDetails.itemCategory !== "" ? <p className="text-black">Category type:- {this.state.filterDetails.itemCategory}</p> : null}
          </div>
          <div class="itemList-table">
            <div class="table-container" style={{ height: "calc(100vh - 200px)" }}>
              {this.state.filterDetails.sortBy === 'Detail' ?
                <table className="itemList">
                  <thead>
                    <tr>
                      <td style={{ width: "10%" }} className="w-[10%]">Prod.No</td>
                      <td style={{ width: "15%" }} className="w-[15%]">Prod.Date</td>
                      <td style={{ width: "25%" }} className="w-[25%]">Product Name</td>
                      <td style={{ width: "10%" }} className="w-[10%]">Batch No</td>
                      <td style={{ width: "10%" }} className="w-[10%]">Batch Size</td>
                      <td style={{ width: "10%" }} className="w-[10%]">Mfg. Date</td>
                      <td style={{ width: "10%" }} className="w-[10%]">Exp. Dt.</td>
                      <td style={{ width: "10%" }} className="w-[10%]">Yield%</td>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.productionRequisitionList &&
                      this.state.productionRequisitionList.length > 0
                      ? this.state.productionRequisitionList.map(
                        (item, key) => (
                          <tr key={key}>
                            <td>{item.productionNo}</td>
                            <td>{item.productionPlanningDate ? moment(item.productionPlanningDate).format("DD MMM yyyy") : ""}</td>
                            <td>{item.productId?.productName ? item.productId?.productName : ""}</td>
                            <td>{item.batchNo}</td>
                            <td>{item.batchSize}</td>
                            <td>{moment(item.mfgDate).format("MM/yyyy")}</td>
                            <td>{moment(item.expDate).format("MM/yyyy")}</td>
                            <td>{item.yieldValue > 0 ? `${item.yieldValue.toFixed(2)}%` : null}</td>
                          </tr>
                        )
                      )
                      : this.state.productionRequisitionList &&
                        this.state.productionRequisitionList.length === 0
                        && this.state.tableStatus !== "" ? (
                        <tr>
                          <td colSpan={8} style={{ textAlign: "center", fontSize: "16px" }}>
                            {this.state.tableStatus}
                          </td>
                        </tr>
                      ) : this.state.productionRequisitionList &&
                        this.state.productionRequisitionList.length === 0
                        && this.state.tableStatus === "" ? null : ""}
                  </tbody>
                </table>
                :
                <table className="itemList">
                  <thead>
                    <tr>
                      <td style={{ width: "7%" }}>Category</td>
                      <td style={{ width: "10%" }}>Batch Size</td>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.categoryTotals &&
                      this.state.categoryTotals.length > 0
                      ? this.state.categoryTotals.map(
                        (item, key) => (
                          <tr key={key}>
                            <td>{item.category}</td>
                            <td>{item.totalBatchSize}</td>
                          </tr>
                        )
                      )
                      : null}
                  </tbody>
                </table>
              }

            </div>
          </div>
        </div>

        {/*----- Print layout -----*/}
        <div className='table-print mt-5 hidden' id="printableArea">
          {/* Header */}
          <div className="print-header">
            <table className="hdr-table">
              <tbody>
                <tr>
                  <td>
                    <div className="co-name">{this.state.companyName}</div>
                    <div className="rpt-sub">Production Register</div>
                  </td>
                  <td>
                    <div className="hdr-meta">
                      Start Date: <strong>{this.state.filterDetails.startDate}</strong><br />
                      End Date: <strong>{this.state.filterDetails.endDate}</strong>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="rule-thick" />
            <div className="rule-thin" />
          </div>


          <div className="print-content">

            {/* <div className="info-row">
                                              <div>
                                                <span className="info-label">Item Name:</span>
                                                <p className="info-value">Paracetamol</p>
                                              </div>
                                            </div> */}

            {/* Table */}
            <table className="data-tbl">
              <colgroup>
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "30%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
              </colgroup>

              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    Prod No
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Prod Date
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Product Name
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Batch No
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Batch Size
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Mfg Date
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Exp Date
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Yield%
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.productionRequisitionList &&
                  this.state.productionRequisitionList.length > 0
                  ? this.state.productionRequisitionList.map(
                    (item, key) => (
                      <tr key={key}>
                        <td style={{ textAlign: 'left' }}>
                          {item.productionNo}
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          {item.productionPlanningDate ? moment(item.productionPlanningDate).format("DD MMM yyyy") : ""}
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          {item.productId?.productName ? item.productId?.productName : ""}
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          {item.batchNo}
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          {item.batchSize}
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          {moment(item.mfgDate).format("MM/yyyy")}
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          {moment(item.expDate).format("MM/yyyy")}
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          {item.yieldValue > 0 ? `${item.yieldValue.toFixed(2)}%` : null}
                        </td>
                      </tr>
                    )) : (
                    <tr>
                      <td colSpan="7" style={{ textAlign: 'center' }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="print-footer">
            <div className="rule-foot">
              <table className="foot-tbl">
                <tbody>
                  <tr>
                    <td>* System generated report. No signature required.</td>
                    <td style={{ textAlign: "right" }}>
                      Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default ProductionBatchRegister;
